module.exports = __webpack_public_path__ + "img/tickets.425b3e45.svg";